import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Lock, Shield, Smartphone, LogOut } from 'lucide-react';
export function SecuritySection() {
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6" data-id="element-2181">
      <h3 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-2182">
        Security & Login
      </h3>

      <div className="space-y-6" data-id="element-2183">
        {/* Password Change */}
        <div className="flex items-center justify-between py-4 border-b border-gray-100" data-id="element-2184">
          <div className="flex items-center" data-id="element-2185">
            <div className="p-2 bg-gray-100 rounded-lg mr-4" data-id="element-2186">
              <Lock className="h-5 w-5 text-gray-600" data-id="element-2187" />
            </div>
            <div data-id="element-2188">
              <p className="text-sm font-medium text-gray-900" data-id="element-2189">
                Change Password
              </p>
              <p className="text-xs text-gray-500" data-id="element-2190">Last changed 3 months ago</p>
            </div>
          </div>
          <button className="text-sm text-blue-600 hover:text-blue-700 font-medium" data-id="element-2191">
            Update
          </button>
        </div>

        {/* 2FA */}
        <div className="flex items-center justify-between py-4 border-b border-gray-100" data-id="element-2192">
          <div className="flex items-center" data-id="element-2193">
            <div className="p-2 bg-gray-100 rounded-lg mr-4" data-id="element-2194">
              <Smartphone className="h-5 w-5 text-gray-600" data-id="element-2195" />
            </div>
            <div data-id="element-2196">
              <p className="text-sm font-medium text-gray-900" data-id="element-2197">
                Two-Factor Authentication
              </p>
              <p className="text-xs text-gray-500" data-id="element-2198">
                Add an extra layer of security
              </p>
            </div>
          </div>
          <button onClick={() => setTwoFactorEnabled(!twoFactorEnabled)} className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${twoFactorEnabled ? 'bg-blue-600' : 'bg-gray-200'}`} data-id="element-2199">
            <span className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${twoFactorEnabled ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-2200" />
          </button>
        </div>

        {/* Active Sessions */}
        <div data-id="element-2201">
          <h4 className="text-sm font-medium text-gray-900 mb-4" data-id="element-2202">
            Active Sessions
          </h4>
          <div className="bg-gray-50 rounded-lg p-4 flex items-center justify-between" data-id="element-2203">
            <div className="flex items-center" data-id="element-2204">
              <div className="h-2 w-2 bg-green-500 rounded-full mr-3" data-id="element-2205"></div>
              <div data-id="element-2206">
                <p className="text-sm font-medium text-gray-900" data-id="element-2207">
                  Chrome on macOS
                </p>
                <p className="text-xs text-gray-500" data-id="element-2208">
                  Lagos, Nigeria • Current Session
                </p>
              </div>
            </div>
            <button className="text-xs text-red-600 hover:text-red-700 font-medium flex items-center" data-id="element-2209">
              <LogOut className="h-3 w-3 mr-1" data-id="element-2210" /> Log out
            </button>
          </div>
        </div>
      </div>
    </div>;
}